import useJwt from "@/auth/jwt/useJwt";

export default {
  data() {
    return {
      track_trace_status_default: [
        {
          id: "T1",
          text: "Booking Approval",
          svg: '<svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.6821 5.17802L4.00001 11.5051V18.3339C4.00001 18.5107 4.07025 18.6802 4.19528 18.8053C4.3203 18.9303 4.48987 19.0005 4.66668 19.0005L9.33583 18.9884C9.51206 18.9876 9.68077 18.9169 9.80508 18.792C9.92938 18.6671 9.99916 18.498 9.99916 18.3218V14.3339C9.99916 14.157 10.0694 13.9875 10.1944 13.8625C10.3194 13.7374 10.489 13.6672 10.6658 13.6672H13.3325C13.5093 13.6672 13.6789 13.7374 13.8039 13.8625C13.9289 13.9875 13.9991 14.157 13.9991 14.3339V18.3189C13.9989 18.4066 14.0159 18.4935 14.0493 18.5746C14.0827 18.6557 14.1317 18.7295 14.1937 18.7916C14.2556 18.8537 14.3292 18.903 14.4102 18.9367C14.4912 18.9703 14.5781 18.9876 14.6658 18.9876L19.3333 19.0005C19.5101 19.0005 19.6797 18.9303 19.8047 18.8053C19.9297 18.6802 20 18.5107 20 18.3339V11.5005L12.3196 5.17802C12.2293 5.10524 12.1168 5.06555 12.0008 5.06555C11.8848 5.06555 11.7724 5.10524 11.6821 5.17802V5.17802ZM23.8166 9.47844L20.3333 6.60719V0.835938C20.3333 0.703329 20.2806 0.576152 20.1868 0.482384C20.0931 0.388616 19.9659 0.335938 19.8333 0.335938H17.5C17.3674 0.335938 17.2402 0.388616 17.1464 0.482384C17.0526 0.576152 17 0.703329 17 0.835938V3.86135L13.2696 0.792188C12.9116 0.497595 12.4624 0.336526 11.9987 0.336526C11.5351 0.336526 11.0859 0.497595 10.7279 0.792188L0.180862 9.47844C0.130232 9.52029 0.0883437 9.5717 0.0575905 9.62974C0.0268373 9.68778 0.00782186 9.75132 0.0016308 9.81671C-0.00456027 9.8821 0.00219434 9.94807 0.0215087 10.0109C0.040823 10.0736 0.0723185 10.132 0.114196 10.1826L1.17669 11.4743C1.21845 11.5251 1.26982 11.5671 1.32786 11.598C1.38589 11.6289 1.44945 11.6481 1.5149 11.6544C1.58034 11.6607 1.64639 11.654 1.70926 11.6348C1.77212 11.6155 1.83058 11.5841 1.88127 11.5422L11.6821 3.46969C11.7724 3.39691 11.8848 3.35722 12.0008 3.35722C12.1168 3.35722 12.2293 3.39691 12.3196 3.46969L22.1208 11.5422C22.1714 11.5841 22.2297 11.6156 22.2925 11.6349C22.3553 11.6542 22.4213 11.6609 22.4867 11.6548C22.5521 11.6486 22.6156 11.6295 22.6736 11.5988C22.7317 11.568 22.7831 11.5262 22.8249 11.4755L23.8874 10.1839C23.9293 10.133 23.9606 10.0743 23.9797 10.0112C23.9988 9.94818 24.0052 9.88197 23.9987 9.81642C23.9921 9.75087 23.9726 9.68726 23.9414 9.62926C23.9101 9.57126 23.8677 9.52 23.8166 9.47844V9.47844Z" fill="white"/></svg>',
          opened: true,
          disabled: true,
          selected: true,
          icon: "step-t1",
          children: [],
        },
        {
          id: "T2",
          text: "In Transit",
          icon: "step-t2",
          svg: '<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M23.4 13.2H22.8V9.14625C22.8 8.67 22.6088 8.2125 22.2713 7.875L18.525 4.12875C18.1875 3.79125 17.73 3.6 17.2538 3.6H15.6V1.8C15.6 0.80625 14.7938 0 13.8 0H1.8C0.80625 0 0 0.80625 0 1.8V13.8C0 14.7938 0.80625 15.6 1.8 15.6H2.4C2.4 17.5875 4.0125 19.2 6 19.2C7.9875 19.2 9.6 17.5875 9.6 15.6H14.4C14.4 17.5875 16.0125 19.2 18 19.2C19.9875 19.2 21.6 17.5875 21.6 15.6H23.4C23.73 15.6 24 15.33 24 15V13.8C24 13.47 23.73 13.2 23.4 13.2ZM6 17.4C5.00625 17.4 4.2 16.5938 4.2 15.6C4.2 14.6063 5.00625 13.8 6 13.8C6.99375 13.8 7.8 14.6063 7.8 15.6C7.8 16.5938 6.99375 17.4 6 17.4ZM18 17.4C17.0063 17.4 16.2 16.5938 16.2 15.6C16.2 14.6063 17.0063 13.8 18 13.8C18.9938 13.8 19.8 14.6063 19.8 15.6C19.8 16.5938 18.9938 17.4 18 17.4ZM21 9.6H15.6V5.4H17.2538L21 9.14625V9.6Z" fill="white"/></g><defs><clipPath id="clip0"><rect width="24" height="19.2" fill="white"/></clipPath></defs></svg>',
          opened: true,
          disabled: true,
          selected: true,
          children: [],
        },
        {
          id: "T3",
          text: "Delivered",
          icon: "step-t3",
          svg: '<svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M24 5.33333L13.2533 0L2.66666 5.33333V6.66667H3.99999V10.6667H6.66666V9.33333H20V21.3333H22.6667V6.66667H24V5.33333ZM7.99999 8V6.66667H10.6667V8H7.99999ZM12 8V6.66667H14.6667V8H12ZM16 8V6.66667H18.6667V8H16Z" fill="white"/><path d="M16 13.3333H14.6667V12H13.3333V16H17.3333V12H16V13.3333Z" fill="white"/><path d="M16 18.6663H14.6667V17.333H13.3333V21.333H17.3333V17.333H16V18.6663Z" fill="white"/></g><g clip-path="url(#clip1)"><path d="M11.7 18.4167H11.4V16.4461C11.4 16.2146 11.3044 15.9922 11.1356 15.8281L9.2625 14.007C9.09375 13.843 8.865 13.75 8.62688 13.75H7.8V12.875C7.8 12.3919 7.39688 12 6.9 12H0.9C0.403125 12 0 12.3919 0 12.875V18.7083C0 19.1914 0.403125 19.5833 0.9 19.5833H1.2C1.2 20.5495 2.00625 21.3333 3 21.3333C3.99375 21.3333 4.8 20.5495 4.8 19.5833H7.2C7.2 20.5495 8.00625 21.3333 9 21.3333C9.99375 21.3333 10.8 20.5495 10.8 19.5833H11.7C11.865 19.5833 12 19.4521 12 19.2917V18.7083C12 18.5479 11.865 18.4167 11.7 18.4167ZM3 20.4583C2.50313 20.4583 2.1 20.0664 2.1 19.5833C2.1 19.1003 2.50313 18.7083 3 18.7083C3.49688 18.7083 3.9 19.1003 3.9 19.5833C3.9 20.0664 3.49688 20.4583 3 20.4583ZM9 20.4583C8.50313 20.4583 8.1 20.0664 8.1 19.5833C8.1 19.1003 8.50313 18.7083 9 18.7083C9.49688 18.7083 9.9 19.1003 9.9 19.5833C9.9 20.0664 9.49688 20.4583 9 20.4583ZM10.5 16.6667H7.8V14.625H8.62688L10.5 16.4461V16.6667Z" fill="white"/></g><defs><clipPath id="clip0"><rect width="21.3333" height="21.3333" fill="white" transform="translate(2.66666)"/></clipPath><clipPath id="clip1"><rect width="12" height="9.33333" fill="white" transform="translate(0 12)"/></clipPath></defs></svg>',
          opened: true,
          disabled: true,
          selected: true,
          children: [],
        },
        {
          id: "T4",
          text: "Payment",
          icon: "step-t4",
          svg: '<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5474 10.1482H19.3162C19.4025 10.1482 19.4873 10.1699 19.5627 10.2113C19.6381 10.2526 19.7017 10.3122 19.7474 10.3846L21.5045 13.1654H23.7456C23.7898 13.1653 23.8332 13.1767 23.8715 13.1983C23.9099 13.2199 23.9419 13.251 23.9644 13.2885C23.987 13.3261 23.9992 13.3688 24 13.4124C24.0007 13.4561 23.99 13.4992 23.9688 13.5375L21.9672 17.1666C21.5194 17.2259 21.0638 17.166 20.6473 16.993C20.2308 16.82 19.8685 16.5402 19.5979 16.1825C19.3613 16.495 19.0543 16.7486 18.7013 16.9232C18.3483 17.0978 17.9589 17.1885 17.5642 17.1882C17.1695 17.1885 16.7802 17.0978 16.4271 16.9232C16.0741 16.7486 15.7671 16.495 15.5305 16.1825C15.2656 16.5326 14.9128 16.8082 14.507 16.982C14.1013 17.1557 13.6567 17.2216 13.2172 17.1731L12.5888 13.7582C12.5755 13.6858 12.5784 13.6113 12.5974 13.54C12.6164 13.4688 12.651 13.4026 12.6987 13.346C12.7464 13.2895 12.8061 13.244 12.8736 13.2127C12.941 13.1815 13.0146 13.1653 13.0891 13.1654H13.4969V10.6511C13.4969 10.5177 13.5504 10.3898 13.6458 10.2955C13.7411 10.2012 13.8704 10.1482 14.0053 10.1482H14.5137V8.63965H16.5474V10.1482ZM14.5137 13.1654H20.3056L19.0346 11.1539H14.5137V13.1654ZM13.4969 18.1939C14.2474 18.195 14.9718 17.9213 15.5305 17.4256C16.0893 17.9213 16.8137 18.195 17.5642 18.1939C18.3148 18.195 19.0392 17.9213 19.5979 17.4256C20.1566 17.9213 20.881 18.195 21.6316 18.1939H22.6484V19.1996H21.6316C20.9176 19.2008 20.216 19.0152 19.5979 18.6616C18.9798 19.0152 18.2782 19.2008 17.5642 19.1996C16.8502 19.2008 16.1486 19.0152 15.5305 18.6616C14.9125 19.0152 14.2109 19.2008 13.4969 19.1996H12.48V18.1939H13.4969Z" fill="white"/><path d="M2.89985 11.1338C3.12592 11.38 3.44344 11.5197 3.77571 11.5193L8.47506 11.5128C8.84592 11.5123 9.21146 11.4245 9.54208 11.2565L20.0164 5.94123C20.9791 5.45272 21.842 4.75541 22.4291 3.84211C23.0883 2.81685 23.1599 2.0749 22.8996 1.55075C22.6401 1.02624 22.009 0.641047 20.8027 0.562569C19.7281 0.49273 18.6593 0.775685 17.6966 1.26384L14.1504 3.06344L6.2773 0.109337C6.18264 0.0455674 6.07267 0.00824015 5.95874 0.00121503C5.84482 -0.00581009 5.73109 0.017722 5.62932 0.0693781L3.26236 1.27068C2.87825 1.46543 2.78537 1.97806 3.07624 2.29774L8.70006 5.82927L4.98457 7.71491L2.38002 6.40202C2.29028 6.35678 2.19117 6.33327 2.09068 6.33339C1.99018 6.33352 1.89113 6.35727 1.80151 6.40274L0.356856 7.13604C-0.0189773 7.32684 -0.117975 7.82435 0.156339 8.1469L2.89985 11.1338Z" fill="white"/></svg>',
          opened: true,
          disabled: true,
          selected: true,
          children: [],
        },
      ],
      isCheckStatus: [],

      track_trace_status: [],
      track_trace_status_tmp: [],

      listInTransit: [
        {
          id: "3.0",
          parentId: "T2",
          idSort: 4,
        },
        {
          id: "3.1",
          parentId: "T2",
          idSort: 5,
        },
        { id: "3.2", parentId: "T2", idSort: 6 },
        { id: "3.3", parentId: "T2", idSort: 7 },
        { id: "3.4", parentId: "T2", idSort: 8 },
        { id: "3.5", parentId: "T2", idSort: 9 },
        { id: "3.6", parentId: "T2", idSort: 10 },
        { id: "3.7", parentId: "T2", idSort: 11 },
        { id: "3.8", parentId: "T2", idSort: 12 },
        { id: "3.9", parentId: "T2", idSort: 13 },
        { id: "3.10", parentId: "T2", idSort: 14 },
        { id: "3.11", parentId: "T2", idSort: 15 },
        { id: "3.12", parentId: "T2", idSort: 16 },
        { id: "3.13", parentId: "T2", idSort: 17 },
        { id: "3.14", parentId: "T2", idSort: 18 },
        { id: "3.15", parentId: "T2", idSort: 19 },
        { id: "3.16", parentId: "T2", idSort: 20 },
        { id: "3.17", parentId: "T2", idSort: 21 },
        { id: "3.18", parentId: "T2", idSort: 22 },
        { id: "3.19", parentId: "T2", idSort: 23 },
        { id: "3.20", parentId: "T2", idSort: 24 },
      ],

      track_trace_service_status: [
        {
          id: 1,
          name: "LCL xuất",
          parent_status_list: ["T1", "T2", "T3", "T4"],
          children_status_list: [
            // {
            //   id: "2.1",
            //   parentId: "T1",
            //   idSort: 1,
            // },
            // {
            //   id: "2.2",
            //   parentId: "T1",
            //   idSort: 2,
            // },
            {
              id: "2.3",
              parentId: "T1",
              idSort: 3,
            },

            { id: "4.1", parentId: "T3", idSort: 25 },
            { id: "5.1", parentId: "T4", idSort: 26 },
            { id: "5.2", parentId: "T4", idSort: 27 },
            { id: "5.3", parentId: "T4", idSort: 28 },
          ],
        },
      ],

      lists: [
        { id: "2.1", text: "Release Booking", group: 1, idStatus: 63 },
        {
          id: "2.2",
          text: "Received Revise Request",
          group: 1,
          idStatus: 62,
        },
        {
          id: "2.3",
          text: "Planned Transportation",
          group: 1,
          idStatus: 7,
        },

        // { id: "3.0", text: "Truck Information", group: 2 },
        { id: "3.1", text: "Empty Picked Up", group: 2, idStatus: 25 },
        { id: "3.2", text: "Arrived At The Warehouse", group: 2, idStatus: 26 },
        { id: "3.3", text: "Picked Up Cargo", group: 2, idStatus: 27 },
        {
          id: "3.4",
          text: "Delivered Cargo To The Port",
          group: 2,
          idStatus: 28,
        },
        {
          id: "3.5",
          text: "Reached The Receiving Location",
          group: 2,
          idStatus: 29,
        },
        { id: "3.6", text: "Picked Up Cargo", group: 2, idStatus: 30 },
        {
          id: "3.7",
          text: "Reached The Delivery Location",
          group: 2,
          idStatus: 31,
        },

        { id: "3.8", text: "Delivered Cargo", group: 2, idStatus: 32 },
        { id: "3.9", text: "Cargo Loaded", group: 2, idStatus: 33 },
        {
          id: "3.10",
          text: "Arrived Destination Port",
          group: 2,
          idStatus: 34,
        },
        { id: "3.11", text: "Release", group: 2, idStatus: 35 },
        {
          id: "3.12",
          text: "Reached The Receiving Location",
          group: 2,
          idStatus: 36,
        },
        { id: "3.13", text: "Picked Up Cargo", group: 2, idStatus: 37 },
        {
          id: "3.14",
          text: "Reached The Delivery Location",
          group: 2,
          idStatus: 38,
        },
        { id: "3.15", text: "Delivered Cargo", group: 2, idStatus: 39 },
        { id: "3.16", text: "Cnee Has Received Cargo", group: 2, idStatus: 40 },
        { id: "3.17", text: "Picked Up Cargo", group: 2, idStatus: 41 },
        {
          id: "3.18",
          text: "Arrived At The Warehouse",
          group: 2,
          idStatus: 42,
        },
        { id: "3.19", text: "Delivered Cargo", group: 2, idStatus: 43 },
        { id: "3.20", text: "Empty Return", group: 2, idStatus: 44 },

        { id: "4.1", text: "Delivered", group: 3, idStatus: 8 },

        { id: "5.1", text: "Unpaid", group: 4, idStatus: 9 },
        { id: "5.2", text: "Paid", group: 4, idStatus: 11 },
        { id: "5.3", text: "Refund", group: 4, idStatus: 13 },
      ],
    };
  },
  methods: {
    async loadTrackTrace() {
      this.track_trace_status = JSON.parse(
        JSON.stringify(this.track_trace_status_default)
      );

      if (this.shipment != null) {
        let temp_children_status_ = [];
        let group_ = await this.getServiceStatusGroupPublic();
        this.track_trace_status = this.track_trace_status.filter(
          (i) => group_.parent_status_list.filter((j) => j == i.id).length > 0
        );
        const op = group_.children_status_list.map((e, i) => {
          let temp = this.lists.find((element) => element.id === e.id);
          if (temp) {
            e = { ...e, ...temp };
          }
          return e;
        });

        var childrenMapIndex = op.map((a, i) => {
          a.index = i;
          return a;
        });
        this.track_trace_status.map((item) => {
          item.children = childrenMapIndex.filter((e) => {
            if (e.parentId == item.id) {
              return { ...e, ...item };
            }
          });
          return item;
        });

        this.track_trace_status.forEach((e) => {
          e.children.sort((a, b) => a.index - b.index);

          e.children.forEach((e) => temp_children_status_.push(e));
          this.shipment.forEach((k) => {
            let x = e.children.filter((j) => j.id === k.id);

            if (x.length > 0 && x[0].id == "4.1") {
              x[0].name = x[0].text;
              x[0].date_ = k.date_;
              x[0].driver_name = k.driver_name;
              x[0].cont_no = k.cont_no;
              x[0].seal_no = k.seal_no;
              x[0].driver_phone = k.driver_phone;

              x[0].driver_card_id = k.driver_card_id;
              x[0].truck_plate = k.truck_plate;

              x[0].HBL = k.hbl;
              x[0].selected = true;
              x[0].text = ` ${x[0].text} 
                       - <b class="text-primary"> 
                      ${k.date_}
                      </b>, HBL: <b class="text-primary"> 
                    ${k.hbl ? k.hbl : " "} 
                      </b>`;
            } else if (x.length > 0) {
              x[0].name = x[0].text;
              x[0].date_ = k.date_;
              x[0].selected = true;
              x[0].driver_name = k.driver_name;
              x[0].driver_phone = k.driver_phone;
              x[0].cont_no = k.cont_no;
              x[0].seal_no = k.seal_no;
              x[0].driver_card_id = k.driver_card_id;
              x[0].truck_plate = k.truck_plate;
              x[0].text =
                x[0].text + ' - <b class="text-primary">' + k.date_ + "</b>";
            }
          });
        }, this);

        for (var i = 0; i < temp_children_status_.length; i++) {
          //Chỉ cho phép cập nhật trạng thái sau trạng thái hiện tại
          //if (i+1<temp_children_status_.length && !temp_children_status_[i].selected){
          //  temp_children_status_[i+1].disabled=true;
          //}
          //Disable các trạng thái trước đó
          if (i - 1 >= 0 && temp_children_status_[i].selected) {
            if (
              this.userData?.userType &&  this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin
            )
              temp_children_status_[i - 1].disabled = true;
            else temp_children_status_[i].disabled = true;
          }

          if (
            ["5.2", "5.3"].includes(temp_children_status_[i].id) && 
            this.userData?.userType &&  this.userData.userType ==
              this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale
          ) {
            temp_children_status_[i].disabled = true;
          }
        }
      }
      this.isCheckStatus = [];
      this.track_trace_status_tmp = [...this.track_trace_status];
      this.track_trace_status_tmp.forEach((e) => {
        if (e.children.find((e) => e.id == "4.1" && e.selected)) {
          return this.isCheckStatus.push(e);
        }
      });
    },
    async getServiceStatusGroup() {
      this.update_status_title = "Update Booking Status";

      // - [" + x.id + "] " + x.name;
      // TODO: get status group
      return new Promise((resolve, reject) => {
        useJwt
          .get(`wr1?objectType=ShipmentInfo`, {
            params: { search: { id: this.request_quotation.id } },
          })
          .then((response) => {
            const sub_status =
              response?.data?.result?.[0]?.list_sub_status?.split(",");
            var track_trace_status = JSON.parse(
              JSON.stringify(this.track_trace_service_status[0])
            );
            track_trace_status.children_status_list.push(
              ...this.listInTransit.filter((e) => sub_status.includes(e.id))
            );
            track_trace_status.children_status_list.sort(
              (a, b) => a.idSort - b.idSort
            );

            resolve(track_trace_status);
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    async getServiceStatusGroupPublic() {
      this.update_status_title = "Update Booking Status";


   

      // - [" + x.id + "] " + x.name;
      // TODO: get status group
      return new Promise((resolve, reject) => {
        useJwt
          .get(`wr1Nologin?objectType=ShipmentInfo`, {
            params: { search: { id: this.request_quotation.id || this.request_quotation.bookingID } },
          })
          .then((response) => {
            const sub_status =
              response?.data?.result?.[0]?.list_sub_status?.split(",");
            var track_trace_status = JSON.parse(
              JSON.stringify(this.track_trace_service_status[0])
            );
            track_trace_status.children_status_list.push(
              ...this.listInTransit.filter((e) => sub_status.includes(e.id))
            );
            track_trace_status.children_status_list.sort(
              (a, b) => a.idSort - b.idSort
            );

            resolve(track_trace_status);
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    
  },
};
